function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSezione04Popup01Ico01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.15 64.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M45.74,29.56l3.73,3.73M49.1,26.2c.49-.49,1.27-.49,1.76,0l1.97,1.97c.49.49.49,1.27,0,1.76l-20.78,20.78h-3.73v-3.73l20.78-20.78ZM28.32,20.86c0-2.75,2.79-4.98,6.22-4.98s6.22,2.23,6.22,4.98M30.59,12.15c0,2.06,1.67,3.73,3.73,3.73s3.73-1.67,3.73-3.73-1.67-3.73-3.73-3.73-3.73,1.67-3.73,3.73ZM23.34,50.71h-14.93M25.83,43.25H8.42M40.76,28.32H8.42M33.3,35.79H8.42M48.23,42.01v19.9c0,.69-.56,1.24-1.24,1.24H2.2c-.69,0-1.24-.56-1.24-1.24V15.88L15.88.95h31.1c.69,0,1.24.56,1.24,1.24v18.66M15.88.95v13.68c0,.69-.56,1.24-1.24,1.24H.95",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSezione04Popup01Ico01);
export default __webpack_public_path__ + "static/media/sezione-04-popup-01-ico-01.d20c26bf019fa594ea44a78551a19ea7.svg";
export { ForwardRef as ReactComponent };